<template>
  <div class="subregion-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <el-table
          :data="subregionList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            type="index"
            :index="tableIndex"
            align="center"
            label="编号"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="title"
            align="center"
            label="分区标题"
          ></el-table-column>
          <el-table-column prop="pic" align="center" label="分区图片">
            <div slot-scope="scope">
              <img class="table-img" :src="scope.row.pic" alt="" />
            </div>
          </el-table-column>
          <!-- <el-table-column
            prop="subtitle"
            align="center"
            label="排序值"
          ></el-table-column> -->
          <el-table-column
            prop="subtitle"
            align="center"
            label="关联商品"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <div slot-scope="scope" style="display: flex">
              <div style="width: 100%">
                <button
                  size="mini"
                  class="table-btn"
                  @click="handleSubregionModal('edit', scope.row)"
                >
                  管理管理商品
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      :visible.sync="addSubregionShow"
      class="dialog"
      width="960px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">99嗨值 - 关联商品</div>
      <div class="good-list">
        <div class="good-item" v-for="item in subregionList" :key="item.id">
          <div class="good">
            <img :src="item.pic" class="pic" alt="" />
            <div class="bottom">
              <div class="name">
                {{ item.title }}
              </div>
              <div class="btn" @click="unbindGood">取消关联</div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="addSubregionShow = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleSubregion"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '商品管理',
        secondTitle: '商品分区管理'
      },
      subregionList: [], // 轮播列表
      rules: {},
      currentSort: 0,
      addSubregionForm: {
        pic: '',
        title: '',
        subtitle: '',
        link: ''
      },
      addSubregionShow: false,
      subregionId: null,
      type: ''
    };
  },
  mounted() {
    // 获取列表
    this.getSubregionList();
  },
  computed: {},
  methods: {
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 获取轮播列表
    getSubregionList() {
      this.loading++;
      this.httpGet(this.$root.getArticleList, {}).then(
        (res) => {
          this.loading--;
          // this.subregionList = [...res.list, ...res.list, ...res.list, ...res.list, ...res.list];
          this.subregionList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 编辑轮播弹窗
    handleSubregionModal(type, rowData) {
      this.subregionId = rowData.id;
      this.addSubregionForm = {
        pic: rowData.pic,
        title: rowData.title,
        subtitle: rowData.subtitle,
        link: rowData.link
      };
      this.addSubregionShow = true;
    },
    // 轮播
    handleSubregion() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading++;
          this.httpPut(this.$root.updateArticle, {
            ...this.addSubregionForm,
            way: 3,
            id: this.subregionId
          }).then(
            (res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.loading--;
              this.addSubregionShow = false;
              this.getSubregionList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    },
    unbindGood() {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要取消商品关联吗</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.updateGoodsStatus, {}).then(
          (res) => {
            this.loading--;
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getSubregionList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 图片改变
    addChangeImg(e) {
      this.upPic(e, (res) => {
        this.$set(this.addSubregionForm, 'pic', res);
        // 清空input value，解决重复图片不触发change
        this.$refs.inputImg.value = '';
        this.$refs.form.clearValidate(['pic']);
      });
    },
    // 上传图片
    upPic(e, fun) {
      // 上传图片
      let file = e.target.files[0];
      if (!file) {
        return;
      }
      this.request.upPic({ prefix: 'other', file: file }).then(
        (res) => {
          fun(res);
        },
        (res) => {}
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.subregion-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 10px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: btn-color;
      }

      // 表格按钮
      .table-btn {
        width: 90px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        confirm-btn();
      }

      .table-img {
        height: 70px;
        width: auto;
      }
    }
  }

  .good-list {
    flex-x(flex-start);
    flex-wrap: wrap;
    max-height: 430px;
    overflow-y: auto;
    overflow-x: hidden;

    .good-item {
      width: (1 / 6) * 100%;
      margin-bottom: 15px;
      flex-y();

      .good {
        width: 140px;
        min-height: 200px;
        flex-y(flex-start);

        .pic {
          width: 140px;
          height: 140px;
        }

        .bottom {
          flex: 1;
          width: 100%;
          background: #F2F2F2;
          flex-y(flex-start, flex-start);

          .name {
            width: 100%;
            word(10px, #333);
            padding: 6px;
          }

          .btn {
            width: 64px;
            height: 22px;
            confirm-btn();
            border-radius: 11px;
            word(10px, #fff);
            flex-x(center);
            align-self: flex-end;
            margin: 3px 8px 8px;
          }
        }
      }
    }
  }

  .addImg {
    .icon {
      width: 270px;
      height: 108px;
    }
  }

  .article-form {
    margin-top: 16px;
    margin-bottom: 60px;
    padding-left: 60px;

    .sort-tip {
      word(14px, #c8c8c8);
      line-height: 20px;
    }
  }
}
</style>
